// extracted by mini-css-extract-plugin
export var buttonContent = "_33-0";
export var centered = "_33-1";
export var centeredFlex = "_33-2";
export var errorText = "_33-3";
export var icon = "_33-4";
export var iconButtonContent = "_33-5";
export var monospace = "_33-6";
export var padded = "_33-7";